import React, { useEffect, useState } from 'react'
import { STEP } from '.'
import useRequesterContext from '../hooks/useRequesterContext'

const HeaderSelectionDropdown = ({ open, name, address, icon, onChange }) => {
  const [expand, setExpand] = useState(open)

  useEffect(() => {
    setExpand(open)
  }, [open])

  const toggle = () => setExpand((prev) => !prev)

  return (
    <div onClick={toggle} className="header-selection-dropdown dome-d-flex dome-flex-column">
      <div className="dome-d-flex dome-align-center dome-justify-between">
        <div className="dome-d-flex dome-align-center dome-gap12">
          <span style={{ padding: '0px 5px' }}>{icon}</span>
          <span className="dome-p1 dome-color-med-grey">{name}</span>
        </div>
        <span aria-expanded={expand} className="header-selection-dropdown-icon">
          <span></span>
          <span></span>
        </span>
      </div>
      <div aria-expanded={expand} className="header-selection-dropdown-content dome-d-flex dome-gap24">
        <div className="header-selection-dropdown-divider"></div>
        <div className="dome-d-flex dome-flex-column dome-align-start dome-gap6">
          {address && <span className="dome-p2 dome-color-med-grey">{address}</span>}
          <button
            type="button"
            style={{ fontSize: '12px' }}
            onClick={onChange}
            className="dome-btn dome-btn-link dome-btn-link-aqua dome-btn-link-chevron-right"
          >
            change
          </button>
        </div>
      </div>
    </div>
  )
}

const HeaderItem = ({ title }) => {
  return (
    <div className="dome-d-flex dome-align-center dome-gap12">
      <span style={{ padding: '0px 5px' }}>
        <i className="fa-light fa-file-lines dome-color-dark-grey"></i>
      </span>
      <span className="dome-p1 dome-color-med-grey">{title}</span>
    </div>
  )
}

export const Header = () => {
  const { formFile, onUpdateStep, step, building, company } = useRequesterContext()
  const expand = step !== STEP.PROPERTY

  return (
    <div className="request-questionnaire-header dome-d-flex dome-flex-column dome-align-start">
      <p className="dome-h2 dome-color-darkest-grey request-questionnaire-header-title">request questionnaire</p>
      <div
        aria-expanded={expand}
        className="request-questionnaire-header-content dome-full-width dome-d-flex dome-flex-column dome-gap6"
      >
        <HeaderSelectionDropdown
          name={building?.address}
          open={step === STEP.COMPANY}
          address={`${building?.city}, ${building?.state}, ${building?.zip}`}
          icon={<i className="fa-regular fa-location-dot dome-color-med-grey"></i>}
          onChange={() => onUpdateStep(STEP.PROPERTY)}
        />
        {(step === STEP.FORM_SELECTION ||
          (step === STEP.FORM_UPLOAD && company.id) ||
          (step === STEP.FORM_REQUEST_INFO && company.name)) && (
          <HeaderSelectionDropdown
            name={company?.name}
            icon={<i className="fa-sharp fa-regular fa-building-columns dome-color-med-grey"></i>}
            onChange={() => onUpdateStep(STEP.COMPANY)}
          />
        )}
        {step === STEP.FORM_REQUEST_INFO && <HeaderItem title={formFile?.file_name} />}
        {step === STEP.FORM_GENERIC && <HeaderItem title="Standard Questionnaire" />}
      </div>
      <div className="request-questionnaire-header-divider"></div>
    </div>
  )
}
